import { useTrads } from "../../contexts/trads/useTrads";

import { useParams } from "react-router";
import { useDonationsByIdQuery } from "../../stores/OkOkStore";
import AppelsItem from "../../components/Appels/AppelsItem";

function AppelItemPage(){
    const params = useParams();
    const { data: fond, error, isLoading } = useDonationsByIdQuery((params.id)??"0");
    const {translate}=useTrads();



  return (
        error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        fond && 
        <AppelsItem fond={fond}   />
  );
}
export default AppelItemPage;